import $ from 'jquery'
import { createApp } from '@app/adapters/create-app'

import PermanentDocumentsUploader from '@app/application/permanent_documents/permanent-documents-uploader'

onDomLoad(function ($dom) {
  $dom.trigger('documentsUploadRendered')
})

$(document).on('documentsUploadRendered', function () {
  const $dom = $(this)
  $dom.find("[data-behaviour='permanent-documents-upload']").each(function () {
    const data = $(this).data()

    const handleFileUploaded = ({ blob }) => {
      const $form = $dom.find(
        "[data-behaviour='permanent-documents-upload-form']"
      )

      const paramsName = `${data.paramsPrefix}[document_direct_upload_path]`
      $form.find(`[name="${paramsName}"]`).remove()
      const $hiddenInput = $('<input>')
        .attr('type', 'hidden')
        .attr('name', paramsName)
        .val(blob.signed_id)
      $form.append($hiddenInput)

      $form
        .find(`[name="${data.paramsPrefix}[document_file_name]"]`)
        .val(blob.filename)

      $form.submit()
    }

    createApp(
      PermanentDocumentsUploader,
      {
        accept: data.accept,
        onFileUploaded: handleFileUploaded,
      },
      {
        singletonId: 'permanent-documents-uploader',
      }
    ).mount(this)
  })
})
